<template>
  <div class="redeem-flow">
    <parameter-router-auth-container v-if="isAuthenticating" initialAuthType="signup" id="redeem-authentication" />
    <redeem-integration v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'redeem-flow',
  props: {
    offer: String
  },
  data: () => ({
    isAuthenticating: true
  }),
  watch: {
    isUserAuthenticated: 'resolveScreen',
    isProfileLoaded: 'resolveScreen',
    isUserSubscribed: 'resolveScreen'
  },
  computed: {
    ...mapState({
      isUserAuthenticated: state => state.authentication.authenticated,
      isProfileLoaded: state => state.user.isProfileLoaded,
      isUserSubscribed: state => state.user.isSubscribed
    })
  },
  methods: {
    resolveScreen() {
      if (this.isAuthenticating) {
        this.isAuthenticating = !this.isUserAuthenticated || !this.isProfileLoaded || this.isUserSubscribed
      }
    }
  },
  created() {
    this.isAuthenticating = !this.isUserAuthenticated
  }
}
</script>

<style lang="scss" scoped>
.redeem-flow {
  flex-grow: 1;
  overflow: visible;

  @media screen and (min-width: 578px) {
    padding: 30px 50px;
  }
}
</style>
